import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchBanner(params) {
  return await request({
    url: ENDPOINT.HOME_BANNER,
    method: "get",
    params,
  });
}

export async function fetchBannerById(id) {
  return await request({
    url: `${ENDPOINT.HOME_BANNER}/${id}/edit`,
    method: "get",
  });
}

export async function createBanner(data) {
  return await request({
    url: ENDPOINT.HOME_BANNER,
    method: "post",
    data,
  });
}

export async function updateBanner(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_BANNER}/${id}`,
    method: "post",
    data,
  });
}